<template lang="pug">
#notation
  .annotation(v-show='notationBoolean')
    .add.item(@click.stop='createdAnnotation')
      van-image(:src='addAanno')
      | 创建批注
      van-icon.layerright(name='arrow')
    .list.item(@click.stop='annotationListClick')
      van-image(:src='annoList')
      | 批注列表
      van-icon.layerright(name='arrow')
  .addNotePic(v-show='addpanel')
    .mpic
      .uploadpic(v-for='(item,index) in base64List' :key='index')
        van-image(:src='item.url' alt='点击截图' @click='cutDwg(index)')
        van-icon(v-show='item.hasKss' name='close' @click='delCutPic(index)')
      .right
        van-image.annotationClose(:src="require('./../../images/pencilClose.png')" alt='关闭' srcset='' @click.stop='closefunc')
        van-image.next(:src="require('./../../images/next.png')" alt='下一步' srcset='' @click.stop='nextfunc')
  //- 创建批注
  notationAdd(ref="notationAdd" :type="actionData.type" @createFinish="finishNotationAdd")
  //- 批注列表
  notationList(ref="notationList")
</template>

<script>
import iconImage from "@/CommonDP/mongeView/appView/images/icon-cutImg.png";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import common from "@/CommonDP/mongeView/appView/component/common";
import notationAdd from "@/CommonDP/mongeView/appView/question/notationAdd.vue";
import notationList from "@/CommonDP/mongeView/appView/question/notationList.vue";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: { notationAdd, notationList },
  data () {
    return {
      addAanno: require("./../../images/modelImage/addAanno.png"),
      annoList: require("./../../images/modelImage/annoList.png"),
      notationBoolean: true,
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false }
      ],
      addpanel: false,
      checkContent: '',
      autoScreenshotMd5: '',
      mark3d: '',
      viewPoint3d: ""// 锚点视口
    };
  },
  computed: {
    spaceOfDwgData() {
      return JSON.parse(mongeApp.map.spaceOfDwgData);
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    }
  },
  methods: {
    // 创建批注
    createdAnnotation() {
      this.notationBoolean = false;
      this.$toast('请长按屏幕拖动到模型创建锚点');
      this.AddMark();
    },
    AddMark() {
      mongeApiMlib.addMark3D('', {
        callback: async(data) => {
          this.mark3d = data;
          this.viewPoint3d = await mongeApiMlib.getViewport();
          this.addpanel = true;
        }
      });
    },
    // 批注列表
    async annotationListClick() {
      let { isH5 } = this.$route.query || {};
      if (isH5) {
        this.openNotationList();
      } else {
        let fileId, fileName, fileVersion;
        if (this.modelInfoData.fileObj) { // 多文件
          fileId = this.modelInfoData.fileObj.map(e => e.folderID).join();
          fileName = this.modelInfoData.fileObj.map(e => e.folderName).join();
          fileVersion = this.modelInfoData.fileObj.map(e => e.rvtVersion).join();
        } else {
          fileId = this.modelInfoData.fileId;
          fileName = this.modelInfoData.fileName;
          fileVersion = this.modelInfoData.rvtVersion;
        }
        const { prjId } = this.modelInfoData;
        const data = {
          fileId, fileName, versionIds: fileVersion, prjId, source: 'list'
        };
        await mongeApiMlib.uniPostMessage(data);
      }
    },
    // 截图
    async cutDwg(val) {
      const cutpic = await common.startScreenShot(this.type);
      this.getAddCutPicList(cutpic, val);
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    // 删除截图
    delCutPic(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },
    closefunc() {
      this.notationBoolean = true;
      this.addpanel = false;
      // this.$emit("closeCom",'modelNotationH5',false)
    },
    // 批注截图下一步
    async nextfunc() {
      let { isH5 } = this.$route.query || {};
      if (isH5) {
        this.openNotationAdd();
      } else {
        this.$toast.loading({
          message: '截图存储中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner'
        });
        this.picList = [];
        for (const index in this.base64List) {
          if (this.base64List[index].hasKss) {
            this.picList.push(await this.getFileMD5(this.base64List[index].url));
          }
        }
        const dataUrl = await mongeApiMlib.mongeScreenCapture(false, this.type);
        const autoScreenshotMd5 = await this.getFileMD5(dataUrl);
        let fileId, fileName, fileVersion;
        if (this.modelInfoData.fileObj) { // 多文件
          fileId = this.modelInfoData.fileObj.map(e => e.folderID).join();
          fileName = this.modelInfoData.fileObj.map(e => e.folderName).join();
          fileVersion = this.modelInfoData.fileObj.map(e => e.rvtVersion).join();
        } else {
          fileId = this.modelInfoData.fileId;
          fileName = this.modelInfoData.fileName;
          fileVersion = this.modelInfoData.rvtVersion;
        }
        const { prjId } = this.modelInfoData;
        const { fileType } = this.$route.query;
        const data = JSON.parse(JSON.stringify({
          fileId,
          fileName,
          fileType,
          versionIds: fileVersion,
          prjId,
          source: 'add',
          picList: this.picList,
          autoScreenshotMd5,
          mark3d: this.mark3d,
          viewPoint3d: this.viewPoint3d
        }));
        console.log('uni模型参数', data);
        await mongeApiMlib.uniPostMessage(data);
        this.$toast.clear();
      }
      setTimeout(() => {
        this.base64List.forEach(itm => {
          itm.url = iconImage;// 清除截图
          itm.hasKss = false;// 去掉叉号
        });
        this.addpanel = false;// 关闭截图弹框
      }, 1500);
    },
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      const res = await mongeService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimeString });
      return blob;
    },

    // 打开创建批注
    openNotationAdd(){
      let { fileId, fileName, rvtVersion, fileObj, prjId } = this.modelInfoData;
      let fileList = []; // 当前文件
      if (fileObj) { // 多文件
        fileList = fileObj.map(ele => {
          return { fileId: ele.folderID, fileName: ele.folderName, fileVersion: ele.rvtVersion };
        });
        fileId = '';
      } else {
        fileList = [{ fileId, fileName, fileVersion: rvtVersion }]; 
      }
      const coordinate = JSON.stringify(this.mark3d);  // 锚点
      const viewPoint = JSON.stringify(this.viewPoint3d);
      let picUrlList = [];
      this.base64List.forEach(pic => {
        if(pic.hasKss) picUrlList.push(pic.url);
      });
      const params = {prjId, fileId, fileList, coordinate, viewPoint, picUrlList};
      this.$refs.notationAdd.open(params);
    },
    // 完成创建批注
    async finishNotationAdd(){
      const autoScreenshotUrl = await mongeApiMlib.mongeScreenCapture(false, this.type);
      const params = { autoScreenshotUrl }; // 自动截图url
      this.$refs.notationAdd?.createFinish(params);
    },
    // 打开批注列表
    openNotationList(){
      let { fileId, fileObj, prjId } = this.modelInfoData;
      let fileIdList = [];
      if(fileObj){
        fileIdList = fileObj.map(ele => ele.folderID);
        fileId = '';
      }
      const params = {prjId, fileId, fileIdList};
      this.$refs.notationList.open(params);
    }
  }
};
</script>

<style lang="scss" scoped>
.annotation{
  position: fixed;
  width: calc(100% - 24px);
  height: 130px;
  margin-left: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #FFFFFF;
  bottom: 70px;
  z-index: 1;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  .item{
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--key-color);
    font-size: 16px;
    .van-image {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
    .layerright{
      margin-left: auto;
      color: var(--key-color);
    }
  }
}

.addNotePic{
  position: fixed;
  width: calc(100% - 24px);
  margin-left: 12px;
  height: 70px;
  bottom: 70px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  z-index: 1;

  .mpic{
    width: 100%;
    height: 100%;
    padding: 0 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic {
      width: 55px;
      height: 55px;
      margin-left: 8px;
      background: rgba(85, 132, 255, 0.1);
      text-align: center;
      position: relative;

      .van-image {
        width: 100%;
        height: 100%;
        display: block;
      }

      .van-icon{
        position: absolute;
        top: 0;
        right: 0;
        font-size: 16px;
        color: #ee0404;
      }

    }

    .uploadpic:first-child{
      margin-left: 0;
    }

    .right{
      margin-left: auto;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;

      .annotationClose {
        width: 15px;
        height: 15px;
        margin-right: 15px;
      }

      .next {
        color: #fff;
        width: 22px;
        height: 22px;
      }
    }
  }
}
</style>
